
export const downloader = {
    fromSvg(svgHtmlElement, fileName) {
      const svgData = svgHtmlElement.outerHTML;
      const svgBlob = new Blob([svgData], {type:"image/svg+xml;charset=utf-8"});
      const svgUrl = URL.createObjectURL(svgBlob);
      this.fromObjectUrl(svgUrl, fileName);
    },
    fromPngCanvas(canvasElement, fileName) {
        const canvasData = canvasElement.toDataURL("image/png");
        this.fromObjectUrl(canvasData, fileName);
    },
    fromObjectUrl(url, fileName) {
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
}